<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78">
      <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1">
          <stop offset="0" stop-color="#43404d"/>
          <stop offset="1" stop-color="#302e39"/>
        </linearGradient>
        <filter id="Ellipse_1" x="0" y="0" width="78" height="78">
          <feOffset/>
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood flood-opacity="0.251"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <g id="Gruppe_9" transform="translate(-279.207 -725.207)">
        <g transform="matrix(1, 0, 0, 1, 279.21, 725.21)">
          <circle id="Ellipse_1-2" cx="30" cy="30" r="30" transform="translate(9 9)" fill="url(#linear-gradient)"/>
        </g>
        <g id="Gruppe_5" transform="translate(305.598 751.89)">
          <g id="Gruppe_4" transform="translate(9.612 5.607)">
            <path id="Pfad_19" d="M20.811,28.621a8.811,8.811,0,1,1,8.811-8.811A8.785,8.785,0,0,1,20.811,28.621Zm0-16.019a7.209,7.209,0,1,0,7.209,7.209A7.179,7.179,0,0,0,20.811,12.6Z" transform="translate(-12 -11)" fill="#fff"/>
            <path id="Pfad_20" d="M35.607,35.408a.727.727,0,0,1-.561-.24L30.24,30.362a.793.793,0,1,1,1.121-1.121l4.806,4.806a.774.774,0,0,1,0,1.121A.727.727,0,0,1,35.607,35.408Z" transform="translate(-15.582 -14.582)" fill="#fff"/>
          </g>
          <path id="Pfad_21" d="M.8,20.825a.757.757,0,0,1-.8-.8V.8A.8.8,0,0,1,.8,0a.757.757,0,0,1,.8.8V20.024A.757.757,0,0,1,.8,20.825Z" fill="#fff"/>
          <path id="Pfad_22" d="M5.8,20.825a.757.757,0,0,1-.8-.8V.8A.8.8,0,0,1,5.8,0a.757.757,0,0,1,.8.8V20.024A.757.757,0,0,1,5.8,20.825Z" transform="translate(-0.995)" fill="#fff"/>
          <g id="Gruppe_3" transform="translate(10.413)">
            <path id="Pfad_23" d="M19.6,6.918V.532c0-.266-.32-.532-.8-.532s-.8.213-.8.532V7.4A7.481,7.481,0,0,1,19.6,6.918Z" transform="translate(-13.995)" fill="#fff"/>
            <path id="Pfad_24" d="M27.6,7.681V.557c0-.278-.32-.557-.8-.557s-.8.223-.8.557V7.236A12.279,12.279,0,0,1,27.6,7.681Z" transform="translate(-15.587)" fill="#fff"/>
            <path id="Pfad_25" d="M14.6.535c0-.267-.32-.535-.8-.535s-.8.214-.8.535V11.877a4.243,4.243,0,0,1,1.6-3.1Z" transform="translate(-13)" fill="#fff"/>
            <path id="Pfad_26" d="M31.8,0c-.481,0-.8.258-.8.645v9.939a5.528,5.528,0,0,1,1.6,3.743V.645C32.6.258,32.282,0,31.8,0Z" transform="translate(-16.582)" fill="#fff"/>
          </g>
          <path id="Schnittmenge_1" d="M4.667,8.048V0A5.592,5.592,0,0,1,7,.505V8.048C7,8.617,6.531,9,5.834,9S4.667,8.617,4.667,8.048ZM.82,8.965A5.3,5.3,0,0,1,0,7.956V2.544A5.4,5.4,0,0,1,2.334.505V8.048c0,.57-.469.952-1.167.952A1.678,1.678,0,0,1,.82,8.965Z" transform="translate(13.609 8.317)" fill="#fff"/>
        </g>
      </g>
    </svg>
</template>

<script>
export default {
  name: "scanBtn"
}
</script>

<style scoped>

</style>